import { render, staticRenderFns } from "./view-driver-cert-content.vue?vue&type=template&id=0cc45d53&scoped=true&"
import script from "./view-driver-cert-content.vue?vue&type=script&lang=js&"
export * from "./view-driver-cert-content.vue?vue&type=script&lang=js&"
import style0 from "./view-driver-cert-content.vue?vue&type=style&index=0&id=0cc45d53&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc45d53",
  null
  
)

export default component.exports